// 职业
export const positionOption = [
    {
        value: "互联网AI",
        label: "互联网AI",
        children: [
            {
                label: "后端开发",
                value: "后端开发",
                // children: [{ label: "java", value: "Java" }],
            },
            {
                label: "前端/移动开发",
                value: "前端/移动开发",
            },
            {
                label: "测试",
                value: "测试",
            },
            {
                label: "运维技术支持",
                value: "运维技术支持",
            },
            {
                label: "人工智能",
                value: "人工智能",
            },
            {
                label: "销售技术支持",
                value: "销售技术支持",
            },
            {
                label: "数据",
                value: "数据",
            },
            {
                label: "技术项目管理",
                value: "技术项目管理",
            },
            {
                label: "高端技术职位",
                value: "高端技术职位",
            },
            {
                label: "其他技术职位",
                value: "其他技术职位",
            },
        ],
    },
    {
        value: "电子/电气/通信",
        label: "电子/电气/通信",
        children: [
            {
                label: "电子/硬件开发",
                value: "电子/硬件开发",
            },
            {
                label: "半导体/芯片",
                value: "半导体/芯片",
            },
            {
                label: "电气/自动化",
                value: "电气/自动化",
            },
            {
                label: "技术项目管理",
                value: "电气/自动化",
            },
            {
                label: "通信",
                value: "通信",
            },
        ],
    },
    {
        value: "产品",
        label: "产品",
        children: [
            {
                label: "产品经理",
                value: "产品经理",
            },
            {
                label: "游戏策划制作",
                value: "游戏策划制作",
            },

        ],
    },
    {
        value: "客服/运营",
        label: "客服/运营",
        children: [
            {
                label: "客服",
                value: "客服",
            },
            {
                label: "内容运营",
                value: "内容运营",
            },
            {
                label: "电商运营",
                value: "电商运营",
            },
            {
                label: "业务运营",
                value: "业务运营",
            },
            {
                label: "线下运营",
                value: "线下运营",
            },
        ],
    },
    {
        value: "销售",
        label: "销售",
    },
    {
        value: "人力/行政/法务",
        label: "人力/行政/法务",
    },
    {
        value: "财务/审计/税务",
        label: "人力/行政/法务",
    },
    {
        value: "生产制造",
        label: "生产制造",
    },
    {
        value: "零售/生活服务",
        label: "零售/生活服务",
    },
    {
        value: "餐饮",
        label: "餐饮",
    },
]
// 城市
export const cityOption = [
    {
        value: "热门城市",
        label: "热门城市",
        children: [
            {
                label: "北京",
                value: "北京",
            },
            {
                label: "上海",
                value: "上海",
            },
            {
                label: "广州",
                value: "广州",
            },
            {
                label: "深圳",
                value: "深圳",
            },
            {
                label: "杭州",
                value: "杭州",
            },
            {
                label: "天津",
                value: "天津",
            },
            {
                label: "西安",
                value: "西安",
            },
            {
                label: "苏州",
                value: "苏州",
            },
        ],
    },
    {
        "value": "北京",
        "label": "北京",
        "children": [
            {
                "value": "北京",
                "label": "北京",

            }
        ]
    },
    {
        "value": "上海",
        "label": "上海",
        "children": [
            {
                "value": "上海",
                "label": "上海",

            }
        ]
    },
    {
        "value": "天津",
        "label": "天津",
        "children": [
            {
                "value": "天津",
                "label": "天津",

            }
        ]
    },
    {
        "value": "重庆",
        "label": "重庆",
        "children": [
            {
                "value": "重庆",
                "label": "重庆",

            }
        ]
    },
    {
        "value": "黑龙江",
        "label": "黑龙江",
        "children": [
            {
                "value": "哈尔滨",
                "label": "哈尔滨",
                "children": [
                    {
                        "value": "哈尔滨",
                        "label": "哈尔滨"
                    },
                    {
                        "value": "尚志市",
                        "label": "尚志市"
                    },
                    {
                        "value": "五常市",
                        "label": "五常市"
                    }
                ]
            },
            {
                "value": "齐齐哈尔",
                "label": "齐齐哈尔",
                "children": [
                    {
                        "value": "齐齐哈尔",
                        "label": "齐齐哈尔"
                    },
                    {
                        "value": "讷河市",
                        "label": "讷河市"
                    }
                ]
            },
            {
                "value": "牡丹江",
                "label": "牡丹江",
                "children": [
                    {
                        "value": "牡丹江",
                        "label": "牡丹江"
                    },
                    {
                        "value": "绥芬河市",
                        "label": "绥芬河市"
                    },
                    {
                        "value": "海林市",
                        "label": "海林市"
                    },
                    {
                        "value": "宁安市",
                        "label": "宁安市"
                    },
                    {
                        "value": "穆棱市",
                        "label": "穆棱市"
                    },
                    {
                        "value": "东宁市",
                        "label": "东宁市"
                    }
                ]
            },
            {
                "value": "佳木斯",
                "label": "佳木斯",
                "children": [
                    {
                        "value": "佳木斯",
                        "label": "佳木斯"
                    },
                    {
                        "value": "同江市",
                        "label": "同江市"
                    },
                    {
                        "value": "富锦市",
                        "label": "富锦市"
                    },
                    {
                        "value": "抚远市",
                        "label": "抚远市"
                    }
                ]
            },
            {
                "value": "绥化",
                "label": "绥化",
                "children": [
                    {
                        "value": "绥化",
                        "label": "绥化"
                    },
                    {
                        "value": "安达市",
                        "label": "安达市"
                    },
                    {
                        "value": "肇东市",
                        "label": "肇东市"
                    },
                    {
                        "value": "海伦市",
                        "label": "海伦市"
                    }
                ]
            },
            {
                "value": "黑河",
                "label": "黑河",
                "children": [
                    {
                        "value": "黑河",
                        "label": "黑河"
                    },
                    {
                        "value": "北安市",
                        "label": "北安市"
                    },
                    {
                        "value": "五大连池市",
                        "label": "五大连池市"
                    },
                    {
                        "value": "嫩江市",
                        "label": "嫩江市"
                    }
                ]
            },
            {
                "value": "伊春",
                "label": "伊春",
                "children": [
                    {
                        "value": "伊春",
                        "label": "伊春"
                    },
                    {
                        "value": "铁力市",
                        "label": "铁力市"
                    }
                ]
            },
            {
                "value": "大庆",
                "label": "大庆",

            },
            {
                "value": "七台河",
                "label": "七台河",

            },
            {
                "value": "鸡西",
                "label": "鸡西",
                "children": [
                    {
                        "value": "鸡西",
                        "label": "鸡西"
                    },
                    {
                        "value": "虎林市",
                        "label": "虎林市"
                    },
                    {
                        "value": "密山市",
                        "label": "密山市"
                    }
                ]
            },
            {
                "value": "鹤岗",
                "label": "鹤岗",

            },
            {
                "value": "双鸭山",
                "label": "双鸭山",

            },
            {
                "value": "大兴安岭地区",
                "label": "大兴安岭地区",
                "children": [
                    {
                        "value": "大兴安岭地区",
                        "label": "大兴安岭地区"
                    },
                    {
                        "value": "漠河市",
                        "label": "漠河市"
                    }
                ]
            }
        ]
    },
    {
        "value": "吉林",
        "label": "吉林",
        "children": [
            {
                "value": "长春",
                "label": "长春",
                "children": [
                    {
                        "value": "长春",
                        "label": "长春"
                    },
                    {
                        "value": "榆树市",
                        "label": "榆树市"
                    },
                    {
                        "value": "德惠市",
                        "label": "德惠市"
                    },
                    {
                        "value": "公主岭市",
                        "label": "公主岭市"
                    }
                ]
            },
            {
                "value": "吉林",
                "label": "吉林",
                "children": [
                    {
                        "value": "吉林",
                        "label": "吉林"
                    },
                    {
                        "value": "蛟河市",
                        "label": "蛟河市"
                    },
                    {
                        "value": "桦甸市",
                        "label": "桦甸市"
                    },
                    {
                        "value": "舒兰市",
                        "label": "舒兰市"
                    },
                    {
                        "value": "磐石市",
                        "label": "磐石市"
                    }
                ]
            },
            {
                "value": "四平",
                "label": "四平",
                "children": [
                    {
                        "value": "四平",
                        "label": "四平"
                    },
                    {
                        "value": "双辽市",
                        "label": "双辽市"
                    }
                ]
            },
            {
                "value": "通化",
                "label": "通化",
                "children": [
                    {
                        "value": "通化",
                        "label": "通化"
                    },
                    {
                        "value": "梅河口市",
                        "label": "梅河口市"
                    },
                    {
                        "value": "集安市",
                        "label": "集安市"
                    }
                ]
            },
            {
                "value": "白城",
                "label": "白城",
                "children": [
                    {
                        "value": "白城",
                        "label": "白城"
                    },
                    {
                        "value": "洮南市",
                        "label": "洮南市"
                    },
                    {
                        "value": "大安市",
                        "label": "大安市"
                    }
                ]
            },
            {
                "value": "辽源",
                "label": "辽源",

            },
            {
                "value": "松原",
                "label": "松原",
                "children": [
                    {
                        "value": "松原",
                        "label": "松原"
                    },
                    {
                        "value": "扶余市",
                        "label": "扶余市"
                    }
                ]
            },
            {
                "value": "白山",
                "label": "白山",
                "children": [
                    {
                        "value": "白山",
                        "label": "白山"
                    },
                    {
                        "value": "临江市",
                        "label": "临江市"
                    }
                ]
            },
            {
                "value": "延边朝鲜族自治州",
                "label": "延边朝鲜族自治州",
                "children": [
                    {
                        "value": "延边朝鲜族自治州",
                        "label": "延边朝鲜族自治州"
                    },
                    {
                        "value": "延吉市",
                        "label": "延吉市"
                    },
                    {
                        "value": "图们市",
                        "label": "图们市"
                    },
                    {
                        "value": "敦化市",
                        "label": "敦化市"
                    },
                    {
                        "value": "珲春市",
                        "label": "珲春市"
                    },
                    {
                        "value": "龙井市",
                        "label": "龙井市"
                    },
                    {
                        "value": "和龙市",
                        "label": "和龙市"
                    }
                ]
            }
        ]
    },
    {
        "value": "辽宁",
        "label": "辽宁",
        "children": [
            {
                "value": "沈阳",
                "label": "沈阳",
                "children": [
                    {
                        "value": "沈阳",
                        "label": "沈阳"
                    },
                    {
                        "value": "新民市",
                        "label": "新民市"
                    }
                ]
            },
            {
                "value": "大连",
                "label": "大连",
                "children": [
                    {
                        "value": "大连",
                        "label": "大连"
                    },
                    {
                        "value": "瓦房店市",
                        "label": "瓦房店市"
                    },
                    {
                        "value": "庄河市",
                        "label": "庄河市"
                    }
                ]
            },
            {
                "value": "鞍山",
                "label": "鞍山",
                "children": [
                    {
                        "value": "鞍山",
                        "label": "鞍山"
                    },
                    {
                        "value": "海城市",
                        "label": "海城市"
                    }
                ]
            },
            {
                "value": "抚顺",
                "label": "抚顺",

            },
            {
                "value": "本溪",
                "label": "本溪",

            },
            {
                "value": "丹东",
                "label": "丹东",
                "children": [
                    {
                        "value": "丹东",
                        "label": "丹东"
                    },
                    {
                        "value": "东港市",
                        "label": "东港市"
                    },
                    {
                        "value": "凤城市",
                        "label": "凤城市"
                    }
                ]
            },
            {
                "value": "锦州",
                "label": "锦州",
                "children": [
                    {
                        "value": "锦州",
                        "label": "锦州"
                    },
                    {
                        "value": "凌海市",
                        "label": "凌海市"
                    },
                    {
                        "value": "北镇市",
                        "label": "北镇市"
                    }
                ]
            },
            {
                "value": "营口",
                "label": "营口",
                "children": [
                    {
                        "value": "营口",
                        "label": "营口"
                    },
                    {
                        "value": "西市区",
                        "label": "西市区"
                    },
                    {
                        "value": "盖州市",
                        "label": "盖州市"
                    },
                    {
                        "value": "大石桥市",
                        "label": "大石桥市"
                    }
                ]
            },
            {
                "value": "阜新",
                "label": "阜新",

            },
            {
                "value": "辽阳",
                "label": "辽阳",
                "children": [
                    {
                        "value": "辽阳",
                        "label": "辽阳"
                    },
                    {
                        "value": "灯塔市",
                        "label": "灯塔市"
                    }
                ]
            },
            {
                "value": "铁岭",
                "label": "铁岭",
                "children": [
                    {
                        "value": "铁岭",
                        "label": "铁岭"
                    },
                    {
                        "value": "调兵山市",
                        "label": "调兵山市"
                    },
                    {
                        "value": "开原市",
                        "label": "开原市"
                    }
                ]
            },
            {
                "value": "朝阳",
                "label": "朝阳",
                "children": [
                    {
                        "value": "朝阳",
                        "label": "朝阳"
                    },
                    {
                        "value": "北票市",
                        "label": "北票市"
                    },
                    {
                        "value": "凌源市",
                        "label": "凌源市"
                    }
                ]
            },
            {
                "value": "盘锦",
                "label": "盘锦",

            },
            {
                "value": "葫芦岛",
                "label": "葫芦岛",
                "children": [
                    {
                        "value": "葫芦岛",
                        "label": "葫芦岛"
                    },
                    {
                        "value": "兴城市",
                        "label": "兴城市"
                    }
                ]
            }
        ]
    },
    {
        "value": "内蒙古",
        "label": "内蒙古",
        "children": [
            {
                "value": "呼和浩特",
                "label": "呼和浩特",

            },
            {
                "value": "包头",
                "label": "包头",

            },
            {
                "value": "乌海",
                "label": "乌海",

            },
            {
                "value": "通辽",
                "label": "通辽",
                "children": [
                    {
                        "value": "通辽",
                        "label": "通辽"
                    },
                    {
                        "value": "霍林郭勒市",
                        "label": "霍林郭勒市"
                    }
                ]
            },
            {
                "value": "赤峰",
                "label": "赤峰",

            },
            {
                "value": "鄂尔多斯",
                "label": "鄂尔多斯",

            },
            {
                "value": "呼伦贝尔",
                "label": "呼伦贝尔",
                "children": [
                    {
                        "value": "呼伦贝尔",
                        "label": "呼伦贝尔"
                    },
                    {
                        "value": "满洲里市",
                        "label": "满洲里市"
                    },
                    {
                        "value": "牙克石市",
                        "label": "牙克石市"
                    },
                    {
                        "value": "扎兰屯市",
                        "label": "扎兰屯市"
                    },
                    {
                        "value": "额尔古纳市",
                        "label": "额尔古纳市"
                    },
                    {
                        "value": "根河市",
                        "label": "根河市"
                    }
                ]
            },
            {
                "value": "巴彦淖尔",
                "label": "巴彦淖尔",

            },
            {
                "value": "乌兰察布",
                "label": "乌兰察布",
                "children": [
                    {
                        "value": "乌兰察布",
                        "label": "乌兰察布"
                    },
                    {
                        "value": "丰镇市",
                        "label": "丰镇市"
                    }
                ]
            },
            {
                "value": "锡林郭勒盟",
                "label": "锡林郭勒盟",
                "children": [
                    {
                        "value": "锡林郭勒盟",
                        "label": "锡林郭勒盟"
                    },
                    {
                        "value": "二连浩特市",
                        "label": "二连浩特市"
                    },
                    {
                        "value": "锡林浩特市",
                        "label": "锡林浩特市"
                    }
                ]
            },
            {
                "value": "兴安盟",
                "label": "兴安盟",
                "children": [
                    {
                        "value": "兴安盟",
                        "label": "兴安盟"
                    },
                    {
                        "value": "乌兰浩特市",
                        "label": "乌兰浩特市"
                    },
                    {
                        "value": "阿尔山市",
                        "label": "阿尔山市"
                    }
                ]
            },
            {
                "value": "阿拉善盟",
                "label": "阿拉善盟",

            }
        ]
    },
    {
        "value": "河北",
        "label": "河北",
        "children": [
            {
                "value": "石家庄",
                "label": "石家庄",
                "children": [
                    {
                        "value": "石家庄",
                        "label": "石家庄"
                    },
                    {
                        "value": "辛集市",
                        "label": "辛集市"
                    },
                    {
                        "value": "晋州市",
                        "label": "晋州市"
                    },
                    {
                        "value": "新乐市",
                        "label": "新乐市"
                    }
                ]
            },
            {
                "value": "保定",
                "label": "保定",
                "children": [
                    {
                        "value": "保定",
                        "label": "保定"
                    },
                    {
                        "value": "涿州市",
                        "label": "涿州市"
                    },
                    {
                        "value": "定州市",
                        "label": "定州市"
                    },
                    {
                        "value": "安国市",
                        "label": "安国市"
                    },
                    {
                        "value": "高碑店市",
                        "label": "高碑店市"
                    }
                ]
            },
            {
                "value": "张家口",
                "label": "张家口",

            },
            {
                "value": "承德",
                "label": "承德",
                "children": [
                    {
                        "value": "承德",
                        "label": "承德"
                    },
                    {
                        "value": "平泉市",
                        "label": "平泉市"
                    }
                ]
            },
            {
                "value": "唐山",
                "label": "唐山",
                "children": [
                    {
                        "value": "唐山",
                        "label": "唐山"
                    },
                    {
                        "value": "遵化市",
                        "label": "遵化市"
                    },
                    {
                        "value": "迁安市",
                        "label": "迁安市"
                    },
                    {
                        "value": "滦州市",
                        "label": "滦州市"
                    }
                ]
            },
            {
                "value": "廊坊",
                "label": "廊坊",
                "children": [
                    {
                        "value": "廊坊",
                        "label": "廊坊"
                    },
                    {
                        "value": "霸州市",
                        "label": "霸州市"
                    },
                    {
                        "value": "三河市",
                        "label": "三河市"
                    }
                ]
            },
            {
                "value": "沧州",
                "label": "沧州",
                "children": [
                    {
                        "value": "沧州",
                        "label": "沧州"
                    },
                    {
                        "value": "泊头市",
                        "label": "泊头市"
                    },
                    {
                        "value": "任丘市",
                        "label": "任丘市"
                    },
                    {
                        "value": "黄骅市",
                        "label": "黄骅市"
                    },
                    {
                        "value": "河间市",
                        "label": "河间市"
                    }
                ]
            },
            {
                "value": "衡水",
                "label": "衡水",
                "children": [
                    {
                        "value": "衡水",
                        "label": "衡水"
                    },
                    {
                        "value": "深州市",
                        "label": "深州市"
                    }
                ]
            },
            {
                "value": "邢台",
                "label": "邢台",
                "children": [
                    {
                        "value": "邢台",
                        "label": "邢台"
                    },
                    {
                        "value": "南宫市",
                        "label": "南宫市"
                    },
                    {
                        "value": "沙河市",
                        "label": "沙河市"
                    }
                ]
            },
            {
                "value": "邯郸",
                "label": "邯郸",
                "children": [
                    {
                        "value": "邯郸",
                        "label": "邯郸"
                    },
                    {
                        "value": "武安市",
                        "label": "武安市"
                    }
                ]
            },
            {
                "value": "秦皇岛",
                "label": "秦皇岛",

            }
        ]
    },
    {
        "value": "山西",
        "label": "山西",
        "children": [
            {
                "value": "太原",
                "label": "太原",
                "children": [
                    {
                        "value": "太原",
                        "label": "太原"
                    },
                    {
                        "value": "古交市",
                        "label": "古交市"
                    }
                ]
            },
            {
                "value": "大同",
                "label": "大同",

            },
            {
                "value": "阳泉",
                "label": "阳泉",

            },
            {
                "value": "晋中",
                "label": "晋中",
                "children": [
                    {
                        "value": "晋中",
                        "label": "晋中"
                    },
                    {
                        "value": "介休市",
                        "label": "介休市"
                    }
                ]
            },
            {
                "value": "长治",
                "label": "长治",

            },
            {
                "value": "晋城",
                "label": "晋城",
                "children": [
                    {
                        "value": "晋城",
                        "label": "晋城"
                    },
                    {
                        "value": "高平市",
                        "label": "高平市"
                    }
                ]
            },
            {
                "value": "临汾",
                "label": "临汾",
                "children": [
                    {
                        "value": "临汾",
                        "label": "临汾"
                    },
                    {
                        "value": "侯马市",
                        "label": "侯马市"
                    },
                    {
                        "value": "霍州市",
                        "label": "霍州市"
                    }
                ]
            },
            {
                "value": "运城",
                "label": "运城",
                "children": [
                    {
                        "value": "运城",
                        "label": "运城"
                    },
                    {
                        "value": "永济市",
                        "label": "永济市"
                    },
                    {
                        "value": "河津市",
                        "label": "河津市"
                    }
                ]
            },
            {
                "value": "朔州",
                "label": "朔州",
                "children": [
                    {
                        "value": "朔州",
                        "label": "朔州"
                    },
                    {
                        "value": "怀仁市",
                        "label": "怀仁市"
                    }
                ]
            },
            {
                "value": "忻州",
                "label": "忻州",
                "children": [
                    {
                        "value": "忻州",
                        "label": "忻州"
                    },
                    {
                        "value": "原平市",
                        "label": "原平市"
                    }
                ]
            },
            {
                "value": "吕梁",
                "label": "吕梁",
                "children": [
                    {
                        "value": "吕梁",
                        "label": "吕梁"
                    },
                    {
                        "value": "孝义市",
                        "label": "孝义市"
                    },
                    {
                        "value": "汾阳市",
                        "label": "汾阳市"
                    }
                ]
            }
        ]
    },
    {
        "value": "陕西",
        "label": "陕西",
        "children": [
            {
                "value": "西安",
                "label": "西安",

            },
            {
                "value": "咸阳",
                "label": "咸阳",
                "children": [
                    {
                        "value": "咸阳",
                        "label": "咸阳"
                    },
                    {
                        "value": "兴平市",
                        "label": "兴平市"
                    },
                    {
                        "value": "彬州市",
                        "label": "彬州市"
                    }
                ]
            },
            {
                "value": "延安",
                "label": "延安",
                "children": [
                    {
                        "value": "延安",
                        "label": "延安"
                    },
                    {
                        "value": "子长市",
                        "label": "子长市"
                    }
                ]
            },
            {
                "value": "榆林",
                "label": "榆林",
                "children": [
                    {
                        "value": "榆林",
                        "label": "榆林"
                    },
                    {
                        "value": "神木市",
                        "label": "神木市"
                    }
                ]
            },
            {
                "value": "渭南",
                "label": "渭南",
                "children": [
                    {
                        "value": "渭南",
                        "label": "渭南"
                    },
                    {
                        "value": "韩城市",
                        "label": "韩城市"
                    },
                    {
                        "value": "华阴市",
                        "label": "华阴市"
                    }
                ]
            },
            {
                "value": "商洛",
                "label": "商洛",

            },
            {
                "value": "安康",
                "label": "安康",
                "children": [
                    {
                        "value": "安康",
                        "label": "安康"
                    },
                    {
                        "value": "旬阳市",
                        "label": "旬阳市"
                    }
                ]
            },
            {
                "value": "汉中",
                "label": "汉中",

            },
            {
                "value": "宝鸡",
                "label": "宝鸡",

            },
            {
                "value": "铜川",
                "label": "铜川",

            }
        ]
    },
    {
        "value": "山东",
        "label": "山东",
        "children": [
            {
                "value": "济南",
                "label": "济南",
                "children": [
                    {
                        "value": "济南",
                        "label": "济南"
                    },
                    {
                        "value": "市中区",
                        "label": "市中区"
                    }
                ]
            },
            {
                "value": "青岛",
                "label": "青岛",
                "children": [
                    {
                        "value": "青岛",
                        "label": "青岛"
                    },
                    {
                        "value": "市南区",
                        "label": "市南区"
                    },
                    {
                        "value": "市北区",
                        "label": "市北区"
                    },
                    {
                        "value": "胶州市",
                        "label": "胶州市"
                    },
                    {
                        "value": "平度市",
                        "label": "平度市"
                    },
                    {
                        "value": "莱西市",
                        "label": "莱西市"
                    }
                ]
            },
            {
                "value": "淄博",
                "label": "淄博",

            },
            {
                "value": "德州",
                "label": "德州",
                "children": [
                    {
                        "value": "德州",
                        "label": "德州"
                    },
                    {
                        "value": "乐陵市",
                        "label": "乐陵市"
                    },
                    {
                        "value": "禹城市",
                        "label": "禹城市"
                    }
                ]
            },
            {
                "value": "烟台",
                "label": "烟台",
                "children": [
                    {
                        "value": "烟台",
                        "label": "烟台"
                    },
                    {
                        "value": "龙口市",
                        "label": "龙口市"
                    },
                    {
                        "value": "莱阳市",
                        "label": "莱阳市"
                    },
                    {
                        "value": "莱州市",
                        "label": "莱州市"
                    },
                    {
                        "value": "招远市",
                        "label": "招远市"
                    },
                    {
                        "value": "栖霞市",
                        "label": "栖霞市"
                    },
                    {
                        "value": "海阳市",
                        "label": "海阳市"
                    }
                ]
            },
            {
                "value": "潍坊",
                "label": "潍坊",
                "children": [
                    {
                        "value": "潍坊",
                        "label": "潍坊"
                    },
                    {
                        "value": "青州市",
                        "label": "青州市"
                    },
                    {
                        "value": "诸城市",
                        "label": "诸城市"
                    },
                    {
                        "value": "寿光市",
                        "label": "寿光市"
                    },
                    {
                        "value": "安丘市",
                        "label": "安丘市"
                    },
                    {
                        "value": "高密市",
                        "label": "高密市"
                    },
                    {
                        "value": "昌邑市",
                        "label": "昌邑市"
                    }
                ]
            },
            {
                "value": "济宁",
                "label": "济宁",
                "children": [
                    {
                        "value": "济宁",
                        "label": "济宁"
                    },
                    {
                        "value": "曲阜市",
                        "label": "曲阜市"
                    },
                    {
                        "value": "邹城市",
                        "label": "邹城市"
                    }
                ]
            },
            {
                "value": "泰安",
                "label": "泰安",
                "children": [
                    {
                        "value": "泰安",
                        "label": "泰安"
                    },
                    {
                        "value": "新泰市",
                        "label": "新泰市"
                    },
                    {
                        "value": "肥城市",
                        "label": "肥城市"
                    }
                ]
            },
            {
                "value": "临沂",
                "label": "临沂",

            },
            {
                "value": "菏泽",
                "label": "菏泽",

            },
            {
                "value": "滨州",
                "label": "滨州",
                "children": [
                    {
                        "value": "滨州",
                        "label": "滨州"
                    },
                    {
                        "value": "邹平市",
                        "label": "邹平市"
                    }
                ]
            },
            {
                "value": "东营",
                "label": "东营",

            },
            {
                "value": "威海",
                "label": "威海",
                "children": [
                    {
                        "value": "威海",
                        "label": "威海"
                    },
                    {
                        "value": "荣成市",
                        "label": "荣成市"
                    },
                    {
                        "value": "乳山市",
                        "label": "乳山市"
                    }
                ]
            },
            {
                "value": "枣庄",
                "label": "枣庄",
                "children": [
                    {
                        "value": "枣庄",
                        "label": "枣庄"
                    },
                    {
                        "value": "市中区",
                        "label": "市中区"
                    },
                    {
                        "value": "滕州市",
                        "label": "滕州市"
                    }
                ]
            },
            {
                "value": "日照",
                "label": "日照",

            },
            {
                "value": "聊城",
                "label": "聊城",
                "children": [
                    {
                        "value": "聊城",
                        "label": "聊城"
                    },
                    {
                        "value": "临清市",
                        "label": "临清市"
                    }
                ]
            }
        ]
    },
    {
        "value": "新疆",
        "label": "新疆",
        "children": [
            {
                "value": "乌鲁木齐",
                "label": "乌鲁木齐",
                "children": [
                    {
                        "value": "乌鲁木齐",
                        "label": "乌鲁木齐"
                    },
                    {
                        "value": "新市区",
                        "label": "新市区"
                    }
                ]
            },
            {
                "value": "克拉玛依",
                "label": "克拉玛依",

            },
            {
                "value": "昌吉回族自治州",
                "label": "昌吉回族自治州",
                "children": [
                    {
                        "value": "昌吉回族自治州",
                        "label": "昌吉回族自治州"
                    },
                    {
                        "value": "昌吉市",
                        "label": "昌吉市"
                    },
                    {
                        "value": "阜康市",
                        "label": "阜康市"
                    }
                ]
            },
            {
                "value": "巴音郭楞蒙古自治州",
                "label": "巴音郭楞蒙古自治州",
                "children": [
                    {
                        "value": "巴音郭楞蒙古自治州",
                        "label": "巴音郭楞蒙古自治州"
                    },
                    {
                        "value": "库尔勒市",
                        "label": "库尔勒市"
                    }
                ]
            },
            {
                "value": "博尔塔拉蒙古自治州",
                "label": "博尔塔拉蒙古自治州",
                "children": [
                    {
                        "value": "博尔塔拉蒙古自治州",
                        "label": "博尔塔拉蒙古自治州"
                    },
                    {
                        "value": "博乐市",
                        "label": "博乐市"
                    },
                    {
                        "value": "阿拉山口市",
                        "label": "阿拉山口市"
                    }
                ]
            },
            {
                "value": "伊犁哈萨克自治州",
                "label": "伊犁哈萨克自治州",
                "children": [
                    {
                        "value": "伊犁哈萨克自治州",
                        "label": "伊犁哈萨克自治州"
                    },
                    {
                        "value": "伊宁市",
                        "label": "伊宁市"
                    },
                    {
                        "value": "奎屯市",
                        "label": "奎屯市"
                    },
                    {
                        "value": "霍尔果斯市",
                        "label": "霍尔果斯市"
                    }
                ]
            },
            {
                "value": "吐鲁番",
                "label": "吐鲁番",

            },
            {
                "value": "哈密",
                "label": "哈密",

            },
            {
                "value": "阿克苏地区",
                "label": "阿克苏地区",
                "children": [
                    {
                        "value": "阿克苏地区",
                        "label": "阿克苏地区"
                    },
                    {
                        "value": "阿克苏市",
                        "label": "阿克苏市"
                    },
                    {
                        "value": "库车市",
                        "label": "库车市"
                    }
                ]
            },
            {
                "value": "克孜勒苏柯尔克孜自治州",
                "label": "克孜勒苏柯尔克孜自治州",
                "children": [
                    {
                        "value": "克孜勒苏柯尔克孜自治州",
                        "label": "克孜勒苏柯尔克孜自治州"
                    },
                    {
                        "value": "阿图什市",
                        "label": "阿图什市"
                    }
                ]
            },
            {
                "value": "喀什地区",
                "label": "喀什地区",
                "children": [
                    {
                        "value": "喀什地区",
                        "label": "喀什地区"
                    },
                    {
                        "value": "喀什市",
                        "label": "喀什市"
                    }
                ]
            },
            {
                "value": "和田地区",
                "label": "和田地区",
                "children": [
                    {
                        "value": "和田地区",
                        "label": "和田地区"
                    },
                    {
                        "value": "和田市",
                        "label": "和田市"
                    }
                ]
            },
            {
                "value": "塔城地区",
                "label": "塔城地区",
                "children": [
                    {
                        "value": "塔城地区",
                        "label": "塔城地区"
                    },
                    {
                        "value": "塔城市",
                        "label": "塔城市"
                    },
                    {
                        "value": "乌苏市",
                        "label": "乌苏市"
                    },
                    {
                        "value": "沙湾市",
                        "label": "沙湾市"
                    }
                ]
            },
            {
                "value": "阿勒泰地区",
                "label": "阿勒泰地区",
                "children": [
                    {
                        "value": "阿勒泰地区",
                        "label": "阿勒泰地区"
                    },
                    {
                        "value": "阿勒泰市",
                        "label": "阿勒泰市"
                    }
                ]
            },
            {
                "value": "石河子",
                "label": "石河子",

            },
            {
                "value": "阿拉尔",
                "label": "阿拉尔",

            },
            {
                "value": "图木舒克",
                "label": "图木舒克",

            },
            {
                "value": "五家渠",
                "label": "五家渠",

            },
            {
                "value": "铁门关",
                "label": "铁门关",

            },
            {
                "value": "北屯市",
                "label": "北屯市",

            },
            {
                "value": "可克达拉市",
                "label": "可克达拉市",

            },
            {
                "value": "昆玉市",
                "label": "昆玉市",

            },
            {
                "value": "双河市",
                "label": "双河市",

            },
            {
                "value": "新星市",
                "label": "新星市",

            },
            {
                "value": "胡杨河市",
                "label": "胡杨河市",

            },
            {
                "value": "白杨市",
                "label": "白杨市",

            }
        ]
    },
    {
        "value": "西藏",
        "label": "西藏",
        "children": [
            {
                "value": "拉萨",
                "label": "拉萨",

            },
            {
                "value": "日喀则",
                "label": "日喀则",

            },
            {
                "value": "昌都",
                "label": "昌都",

            },
            {
                "value": "林芝",
                "label": "林芝",

            },
            {
                "value": "山南",
                "label": "山南",

            },
            {
                "value": "那曲",
                "label": "那曲",

            },
            {
                "value": "阿里地区",
                "label": "阿里地区",

            }
        ]
    },
    {
        "value": "青海",
        "label": "青海",
        "children": [
            {
                "value": "西宁",
                "label": "西宁",

            },
            {
                "value": "海东",
                "label": "海东",

            },
            {
                "value": "海北藏族自治州",
                "label": "海北藏族自治州",

            },
            {
                "value": "黄南藏族自治州",
                "label": "黄南藏族自治州",
                "children": [
                    {
                        "value": "黄南藏族自治州",
                        "label": "黄南藏族自治州"
                    },
                    {
                        "value": "同仁市",
                        "label": "同仁市"
                    }
                ]
            },
            {
                "value": "海南藏族自治州",
                "label": "海南藏族自治州",

            },
            {
                "value": "果洛藏族自治州",
                "label": "果洛藏族自治州",

            },
            {
                "value": "玉树藏族自治州",
                "label": "玉树藏族自治州",
                "children": [
                    {
                        "value": "玉树藏族自治州",
                        "label": "玉树藏族自治州"
                    },
                    {
                        "value": "玉树市",
                        "label": "玉树市"
                    }
                ]
            },
            {
                "value": "海西蒙古族藏族自治州",
                "label": "海西蒙古族藏族自治州",
                "children": [
                    {
                        "value": "海西蒙古族藏族自治州",
                        "label": "海西蒙古族藏族自治州"
                    },
                    {
                        "value": "格尔木市",
                        "label": "格尔木市"
                    },
                    {
                        "value": "德令哈市",
                        "label": "德令哈市"
                    },
                    {
                        "value": "茫崖市",
                        "label": "茫崖市"
                    }
                ]
            }
        ]
    },
    {
        "value": "甘肃",
        "label": "甘肃",
        "children": [
            {
                "value": "兰州",
                "label": "兰州",

            },
            {
                "value": "定西",
                "label": "定西",

            },
            {
                "value": "平凉",
                "label": "平凉",
                "children": [
                    {
                        "value": "平凉",
                        "label": "平凉"
                    },
                    {
                        "value": "华亭市",
                        "label": "华亭市"
                    }
                ]
            },
            {
                "value": "庆阳",
                "label": "庆阳",

            },
            {
                "value": "武威",
                "label": "武威",

            },
            {
                "value": "金昌",
                "label": "金昌",

            },
            {
                "value": "张掖",
                "label": "张掖",

            },
            {
                "value": "酒泉",
                "label": "酒泉",
                "children": [
                    {
                        "value": "酒泉",
                        "label": "酒泉"
                    },
                    {
                        "value": "玉门市",
                        "label": "玉门市"
                    },
                    {
                        "value": "敦煌市",
                        "label": "敦煌市"
                    }
                ]
            },
            {
                "value": "天水",
                "label": "天水",

            },
            {
                "value": "白银",
                "label": "白银",

            },
            {
                "value": "陇南",
                "label": "陇南",

            },
            {
                "value": "嘉峪关",
                "label": "嘉峪关",

            },
            {
                "value": "临夏回族自治州",
                "label": "临夏回族自治州",
                "children": [
                    {
                        "value": "临夏回族自治州",
                        "label": "临夏回族自治州"
                    },
                    {
                        "value": "临夏市",
                        "label": "临夏市"
                    }
                ]
            },
            {
                "value": "甘南藏族自治州",
                "label": "甘南藏族自治州",
                "children": [
                    {
                        "value": "甘南藏族自治州",
                        "label": "甘南藏族自治州"
                    },
                    {
                        "value": "合作市",
                        "label": "合作市"
                    }
                ]
            }
        ]
    },
    {
        "value": "宁夏",
        "label": "宁夏",
        "children": [
            {
                "value": "银川",
                "label": "银川",
                "children": [
                    {
                        "value": "银川",
                        "label": "银川"
                    },
                    {
                        "value": "灵武市",
                        "label": "灵武市"
                    }
                ]
            },
            {
                "value": "石嘴山",
                "label": "石嘴山",

            },
            {
                "value": "吴忠",
                "label": "吴忠",
                "children": [
                    {
                        "value": "吴忠",
                        "label": "吴忠"
                    },
                    {
                        "value": "青铜峡市",
                        "label": "青铜峡市"
                    }
                ]
            },
            {
                "value": "固原",
                "label": "固原",

            },
            {
                "value": "中卫",
                "label": "中卫",

            }
        ]
    },
    {
        "value": "河南",
        "label": "河南",
        "children": [
            {
                "value": "郑州",
                "label": "郑州",
                "children": [
                    {
                        "value": "郑州",
                        "label": "郑州"
                    },
                    {
                        "value": "巩义市",
                        "label": "巩义市"
                    },
                    {
                        "value": "荥阳市",
                        "label": "荥阳市"
                    },
                    {
                        "value": "新密市",
                        "label": "新密市"
                    },
                    {
                        "value": "新郑市",
                        "label": "新郑市"
                    },
                    {
                        "value": "登封市",
                        "label": "登封市"
                    }
                ]
            },
            {
                "value": "安阳",
                "label": "安阳",
                "children": [
                    {
                        "value": "安阳",
                        "label": "安阳"
                    },
                    {
                        "value": "林州市",
                        "label": "林州市"
                    }
                ]
            },
            {
                "value": "新乡",
                "label": "新乡",
                "children": [
                    {
                        "value": "新乡",
                        "label": "新乡"
                    },
                    {
                        "value": "卫辉市",
                        "label": "卫辉市"
                    },
                    {
                        "value": "辉县市",
                        "label": "辉县市"
                    },
                    {
                        "value": "长垣市",
                        "label": "长垣市"
                    }
                ]
            },
            {
                "value": "许昌",
                "label": "许昌",
                "children": [
                    {
                        "value": "许昌",
                        "label": "许昌"
                    },
                    {
                        "value": "禹州市",
                        "label": "禹州市"
                    },
                    {
                        "value": "长葛市",
                        "label": "长葛市"
                    }
                ]
            },
            {
                "value": "平顶山",
                "label": "平顶山",
                "children": [
                    {
                        "value": "平顶山",
                        "label": "平顶山"
                    },
                    {
                        "value": "舞钢市",
                        "label": "舞钢市"
                    },
                    {
                        "value": "汝州市",
                        "label": "汝州市"
                    }
                ]
            },
            {
                "value": "信阳",
                "label": "信阳",

            },
            {
                "value": "南阳",
                "label": "南阳",
                "children": [
                    {
                        "value": "南阳",
                        "label": "南阳"
                    },
                    {
                        "value": "邓州市",
                        "label": "邓州市"
                    }
                ]
            },
            {
                "value": "开封",
                "label": "开封",

            },
            {
                "value": "洛阳",
                "label": "洛阳",

            },
            {
                "value": "商丘",
                "label": "商丘",
                "children": [
                    {
                        "value": "商丘",
                        "label": "商丘"
                    },
                    {
                        "value": "永城市",
                        "label": "永城市"
                    }
                ]
            },
            {
                "value": "焦作",
                "label": "焦作",
                "children": [
                    {
                        "value": "焦作",
                        "label": "焦作"
                    },
                    {
                        "value": "沁阳市",
                        "label": "沁阳市"
                    },
                    {
                        "value": "孟州市",
                        "label": "孟州市"
                    }
                ]
            },
            {
                "value": "鹤壁",
                "label": "鹤壁",

            },
            {
                "value": "濮阳",
                "label": "濮阳",

            },
            {
                "value": "周口",
                "label": "周口",
                "children": [
                    {
                        "value": "周口",
                        "label": "周口"
                    },
                    {
                        "value": "项城市",
                        "label": "项城市"
                    }
                ]
            },
            {
                "value": "漯河",
                "label": "漯河",

            },
            {
                "value": "驻马店",
                "label": "驻马店",

            },
            {
                "value": "三门峡",
                "label": "三门峡",
                "children": [
                    {
                        "value": "三门峡",
                        "label": "三门峡"
                    },
                    {
                        "value": "义马市",
                        "label": "义马市"
                    },
                    {
                        "value": "灵宝市",
                        "label": "灵宝市"
                    }
                ]
            },
            {
                "value": "济源",
                "label": "济源",

            }
        ]
    },
    {
        "value": "江苏",
        "label": "江苏",
        "children": [
            {
                "value": "南京",
                "label": "南京",

            },
            {
                "value": "无锡",
                "label": "无锡",
                "children": [
                    {
                        "value": "无锡",
                        "label": "无锡"
                    },
                    {
                        "value": "江阴市",
                        "label": "江阴市"
                    },
                    {
                        "value": "宜兴市",
                        "label": "宜兴市"
                    }
                ]
            },
            {
                "value": "镇江",
                "label": "镇江",
                "children": [
                    {
                        "value": "镇江",
                        "label": "镇江"
                    },
                    {
                        "value": "丹阳市",
                        "label": "丹阳市"
                    },
                    {
                        "value": "扬中市",
                        "label": "扬中市"
                    },
                    {
                        "value": "句容市",
                        "label": "句容市"
                    }
                ]
            },
            {
                "value": "苏州",
                "label": "苏州",
                "children": [
                    {
                        "value": "苏州",
                        "label": "苏州"
                    },
                    {
                        "value": "常熟市",
                        "label": "常熟市"
                    },
                    {
                        "value": "张家港市",
                        "label": "张家港市"
                    },
                    {
                        "value": "昆山市",
                        "label": "昆山市"
                    },
                    {
                        "value": "太仓市",
                        "label": "太仓市"
                    }
                ]
            },
            {
                "value": "南通",
                "label": "南通",
                "children": [
                    {
                        "value": "南通",
                        "label": "南通"
                    },
                    {
                        "value": "启东市",
                        "label": "启东市"
                    },
                    {
                        "value": "如皋市",
                        "label": "如皋市"
                    },
                    {
                        "value": "海安市",
                        "label": "海安市"
                    }
                ]
            },
            {
                "value": "扬州",
                "label": "扬州",
                "children": [
                    {
                        "value": "扬州",
                        "label": "扬州"
                    },
                    {
                        "value": "仪征市",
                        "label": "仪征市"
                    },
                    {
                        "value": "高邮市",
                        "label": "高邮市"
                    }
                ]
            },
            {
                "value": "盐城",
                "label": "盐城",
                "children": [
                    {
                        "value": "盐城",
                        "label": "盐城"
                    },
                    {
                        "value": "东台市",
                        "label": "东台市"
                    }
                ]
            },
            {
                "value": "徐州",
                "label": "徐州",
                "children": [
                    {
                        "value": "徐州",
                        "label": "徐州"
                    },
                    {
                        "value": "新沂市",
                        "label": "新沂市"
                    },
                    {
                        "value": "邳州市",
                        "label": "邳州市"
                    }
                ]
            },
            {
                "value": "淮安",
                "label": "淮安",

            },
            {
                "value": "连云港",
                "label": "连云港",

            },
            {
                "value": "常州",
                "label": "常州",
                "children": [
                    {
                        "value": "常州",
                        "label": "常州"
                    },
                    {
                        "value": "溧阳市",
                        "label": "溧阳市"
                    }
                ]
            },
            {
                "value": "泰州",
                "label": "泰州",
                "children": [
                    {
                        "value": "泰州",
                        "label": "泰州"
                    },
                    {
                        "value": "兴化市",
                        "label": "兴化市"
                    },
                    {
                        "value": "靖江市",
                        "label": "靖江市"
                    },
                    {
                        "value": "泰兴市",
                        "label": "泰兴市"
                    }
                ]
            },
            {
                "value": "宿迁",
                "label": "宿迁",

            }
        ]
    },
    {
        "value": "湖北",
        "label": "湖北",
        "children": [
            {
                "value": "武汉",
                "label": "武汉",

            },
            {
                "value": "襄阳",
                "label": "襄阳",
                "children": [
                    {
                        "value": "襄阳",
                        "label": "襄阳"
                    },
                    {
                        "value": "老河口市",
                        "label": "老河口市"
                    },
                    {
                        "value": "枣阳市",
                        "label": "枣阳市"
                    },
                    {
                        "value": "宜城市",
                        "label": "宜城市"
                    }
                ]
            },
            {
                "value": "鄂州",
                "label": "鄂州",

            },
            {
                "value": "孝感",
                "label": "孝感",
                "children": [
                    {
                        "value": "孝感",
                        "label": "孝感"
                    },
                    {
                        "value": "应城市",
                        "label": "应城市"
                    },
                    {
                        "value": "安陆市",
                        "label": "安陆市"
                    },
                    {
                        "value": "汉川市",
                        "label": "汉川市"
                    }
                ]
            },
            {
                "value": "黄冈",
                "label": "黄冈",
                "children": [
                    {
                        "value": "黄冈",
                        "label": "黄冈"
                    },
                    {
                        "value": "麻城市",
                        "label": "麻城市"
                    },
                    {
                        "value": "武穴市",
                        "label": "武穴市"
                    }
                ]
            },
            {
                "value": "黄石",
                "label": "黄石",
                "children": [
                    {
                        "value": "黄石",
                        "label": "黄石"
                    },
                    {
                        "value": "大冶市",
                        "label": "大冶市"
                    }
                ]
            },
            {
                "value": "咸宁",
                "label": "咸宁",
                "children": [
                    {
                        "value": "咸宁",
                        "label": "咸宁"
                    },
                    {
                        "value": "赤壁市",
                        "label": "赤壁市"
                    }
                ]
            },
            {
                "value": "荆州",
                "label": "荆州",
                "children": [
                    {
                        "value": "荆州",
                        "label": "荆州"
                    },
                    {
                        "value": "沙市区",
                        "label": "沙市区"
                    },
                    {
                        "value": "监利市",
                        "label": "监利市"
                    },
                    {
                        "value": "石首市",
                        "label": "石首市"
                    },
                    {
                        "value": "洪湖市",
                        "label": "洪湖市"
                    },
                    {
                        "value": "松滋市",
                        "label": "松滋市"
                    }
                ]
            },
            {
                "value": "宜昌",
                "label": "宜昌",
                "children": [
                    {
                        "value": "宜昌",
                        "label": "宜昌"
                    },
                    {
                        "value": "宜都市",
                        "label": "宜都市"
                    },
                    {
                        "value": "当阳市",
                        "label": "当阳市"
                    },
                    {
                        "value": "枝江市",
                        "label": "枝江市"
                    }
                ]
            },
            {
                "value": "十堰",
                "label": "十堰",
                "children": [
                    {
                        "value": "十堰",
                        "label": "十堰"
                    },
                    {
                        "value": "丹江口市",
                        "label": "丹江口市"
                    }
                ]
            },
            {
                "value": "随州",
                "label": "随州",
                "children": [
                    {
                        "value": "随州",
                        "label": "随州"
                    },
                    {
                        "value": "广水市",
                        "label": "广水市"
                    }
                ]
            },
            {
                "value": "荆门",
                "label": "荆门",
                "children": [
                    {
                        "value": "荆门",
                        "label": "荆门"
                    },
                    {
                        "value": "钟祥市",
                        "label": "钟祥市"
                    },
                    {
                        "value": "京山市",
                        "label": "京山市"
                    }
                ]
            },
            {
                "value": "恩施土家族苗族自治州",
                "label": "恩施土家族苗族自治州",
                "children": [
                    {
                        "value": "恩施土家族苗族自治州",
                        "label": "恩施土家族苗族自治州"
                    },
                    {
                        "value": "恩施市",
                        "label": "恩施市"
                    },
                    {
                        "value": "利川市",
                        "label": "利川市"
                    }
                ]
            },
            {
                "value": "仙桃",
                "label": "仙桃",

            },
            {
                "value": "潜江",
                "label": "潜江",

            },
            {
                "value": "天门",
                "label": "天门",

            },
            {
                "value": "神农架",
                "label": "神农架",

            }
        ]
    },
    {
        "value": "浙江",
        "label": "浙江",
        "children": [
            {
                "value": "杭州",
                "label": "杭州",
                "children": [
                    {
                        "value": "杭州",
                        "label": "杭州"
                    },
                    {
                        "value": "建德市",
                        "label": "建德市"
                    }
                ]
            },
            {
                "value": "湖州",
                "label": "湖州",

            },
            {
                "value": "嘉兴",
                "label": "嘉兴",
                "children": [
                    {
                        "value": "嘉兴",
                        "label": "嘉兴"
                    },
                    {
                        "value": "海宁市",
                        "label": "海宁市"
                    },
                    {
                        "value": "平湖市",
                        "label": "平湖市"
                    },
                    {
                        "value": "桐乡市",
                        "label": "桐乡市"
                    }
                ]
            },
            {
                "value": "宁波",
                "label": "宁波",
                "children": [
                    {
                        "value": "宁波",
                        "label": "宁波"
                    },
                    {
                        "value": "余姚市",
                        "label": "余姚市"
                    },
                    {
                        "value": "慈溪市",
                        "label": "慈溪市"
                    }
                ]
            },
            {
                "value": "绍兴",
                "label": "绍兴",
                "children": [
                    {
                        "value": "绍兴",
                        "label": "绍兴"
                    },
                    {
                        "value": "诸暨市",
                        "label": "诸暨市"
                    },
                    {
                        "value": "嵊州市",
                        "label": "嵊州市"
                    }
                ]
            },
            {
                "value": "台州",
                "label": "台州",
                "children": [
                    {
                        "value": "台州",
                        "label": "台州"
                    },
                    {
                        "value": "温岭市",
                        "label": "温岭市"
                    },
                    {
                        "value": "临海市",
                        "label": "临海市"
                    },
                    {
                        "value": "玉环市",
                        "label": "玉环市"
                    }
                ]
            },
            {
                "value": "温州",
                "label": "温州",
                "children": [
                    {
                        "value": "温州",
                        "label": "温州"
                    },
                    {
                        "value": "瑞安市",
                        "label": "瑞安市"
                    },
                    {
                        "value": "乐清市",
                        "label": "乐清市"
                    },
                    {
                        "value": "龙港市",
                        "label": "龙港市"
                    }
                ]
            },
            {
                "value": "丽水",
                "label": "丽水",
                "children": [
                    {
                        "value": "丽水",
                        "label": "丽水"
                    },
                    {
                        "value": "龙泉市",
                        "label": "龙泉市"
                    }
                ]
            },
            {
                "value": "金华",
                "label": "金华",
                "children": [
                    {
                        "value": "金华",
                        "label": "金华"
                    },
                    {
                        "value": "兰溪市",
                        "label": "兰溪市"
                    },
                    {
                        "value": "义乌市",
                        "label": "义乌市"
                    },
                    {
                        "value": "东阳市",
                        "label": "东阳市"
                    },
                    {
                        "value": "永康市",
                        "label": "永康市"
                    }
                ]
            },
            {
                "value": "衢州",
                "label": "衢州",
                "children": [
                    {
                        "value": "衢州",
                        "label": "衢州"
                    },
                    {
                        "value": "江山市",
                        "label": "江山市"
                    }
                ]
            },
            {
                "value": "舟山",
                "label": "舟山",

            }
        ]
    },
    {
        "value": "安徽",
        "label": "安徽",
        "children": [
            {
                "value": "合肥",
                "label": "合肥",
                "children": [
                    {
                        "value": "合肥",
                        "label": "合肥"
                    },
                    {
                        "value": "巢湖市",
                        "label": "巢湖市"
                    }
                ]
            },
            {
                "value": "蚌埠",
                "label": "蚌埠",

            },
            {
                "value": "芜湖",
                "label": "芜湖",
                "children": [
                    {
                        "value": "芜湖",
                        "label": "芜湖"
                    },
                    {
                        "value": "无为市",
                        "label": "无为市"
                    }
                ]
            },
            {
                "value": "淮南",
                "label": "淮南",

            },
            {
                "value": "马鞍山",
                "label": "马鞍山",

            },
            {
                "value": "安庆",
                "label": "安庆",
                "children": [
                    {
                        "value": "安庆",
                        "label": "安庆"
                    },
                    {
                        "value": "桐城市",
                        "label": "桐城市"
                    },
                    {
                        "value": "潜山市",
                        "label": "潜山市"
                    }
                ]
            },
            {
                "value": "宿州",
                "label": "宿州",

            },
            {
                "value": "阜阳",
                "label": "阜阳",
                "children": [
                    {
                        "value": "阜阳",
                        "label": "阜阳"
                    },
                    {
                        "value": "界首市",
                        "label": "界首市"
                    }
                ]
            },
            {
                "value": "亳州",
                "label": "亳州",

            },
            {
                "value": "滁州",
                "label": "滁州",
                "children": [
                    {
                        "value": "滁州",
                        "label": "滁州"
                    },
                    {
                        "value": "天长市",
                        "label": "天长市"
                    },
                    {
                        "value": "明光市",
                        "label": "明光市"
                    }
                ]
            },
            {
                "value": "淮北",
                "label": "淮北",

            },
            {
                "value": "铜陵",
                "label": "铜陵",

            },
            {
                "value": "宣城",
                "label": "宣城",
                "children": [
                    {
                        "value": "宣城",
                        "label": "宣城"
                    },
                    {
                        "value": "宁国市",
                        "label": "宁国市"
                    },
                    {
                        "value": "广德市",
                        "label": "广德市"
                    }
                ]
            },
            {
                "value": "六安",
                "label": "六安",

            },
            {
                "value": "池州",
                "label": "池州",

            },
            {
                "value": "黄山",
                "label": "黄山",

            }
        ]
    },
    {
        "value": "福建",
        "label": "福建",
        "children": [
            {
                "value": "福州",
                "label": "福州",
                "children": [
                    {
                        "value": "福州",
                        "label": "福州"
                    },
                    {
                        "value": "福清市",
                        "label": "福清市"
                    }
                ]
            },
            {
                "value": "厦门",
                "label": "厦门",

            },
            {
                "value": "宁德",
                "label": "宁德",
                "children": [
                    {
                        "value": "宁德",
                        "label": "宁德"
                    },
                    {
                        "value": "福安市",
                        "label": "福安市"
                    },
                    {
                        "value": "福鼎市",
                        "label": "福鼎市"
                    }
                ]
            },
            {
                "value": "莆田",
                "label": "莆田",

            },
            {
                "value": "泉州",
                "label": "泉州",
                "children": [
                    {
                        "value": "泉州",
                        "label": "泉州"
                    },
                    {
                        "value": "石狮市",
                        "label": "石狮市"
                    },
                    {
                        "value": "晋江市",
                        "label": "晋江市"
                    },
                    {
                        "value": "南安市",
                        "label": "南安市"
                    }
                ]
            },
            {
                "value": "漳州",
                "label": "漳州",

            },
            {
                "value": "龙岩",
                "label": "龙岩",
                "children": [
                    {
                        "value": "龙岩",
                        "label": "龙岩"
                    },
                    {
                        "value": "漳平市",
                        "label": "漳平市"
                    }
                ]
            },
            {
                "value": "三明",
                "label": "三明",
                "children": [
                    {
                        "value": "三明",
                        "label": "三明"
                    },
                    {
                        "value": "永安市",
                        "label": "永安市"
                    }
                ]
            },
            {
                "value": "南平",
                "label": "南平",
                "children": [
                    {
                        "value": "南平",
                        "label": "南平"
                    },
                    {
                        "value": "邵武市",
                        "label": "邵武市"
                    },
                    {
                        "value": "武夷山市",
                        "label": "武夷山市"
                    },
                    {
                        "value": "建瓯市",
                        "label": "建瓯市"
                    }
                ]
            }
        ]
    },
    {
        "value": "江西",
        "label": "江西",
        "children": [
            {
                "value": "南昌",
                "label": "南昌",

            },
            {
                "value": "九江",
                "label": "九江",
                "children": [
                    {
                        "value": "九江",
                        "label": "九江"
                    },
                    {
                        "value": "瑞昌市",
                        "label": "瑞昌市"
                    },
                    {
                        "value": "共青城市",
                        "label": "共青城市"
                    },
                    {
                        "value": "庐山市",
                        "label": "庐山市"
                    }
                ]
            },
            {
                "value": "上饶",
                "label": "上饶",
                "children": [
                    {
                        "value": "上饶",
                        "label": "上饶"
                    },
                    {
                        "value": "德兴市",
                        "label": "德兴市"
                    }
                ]
            },
            {
                "value": "抚州",
                "label": "抚州",

            },
            {
                "value": "宜春",
                "label": "宜春",
                "children": [
                    {
                        "value": "宜春",
                        "label": "宜春"
                    },
                    {
                        "value": "丰城市",
                        "label": "丰城市"
                    },
                    {
                        "value": "樟树市",
                        "label": "樟树市"
                    },
                    {
                        "value": "高安市",
                        "label": "高安市"
                    }
                ]
            },
            {
                "value": "吉安",
                "label": "吉安",
                "children": [
                    {
                        "value": "吉安",
                        "label": "吉安"
                    },
                    {
                        "value": "井冈山市",
                        "label": "井冈山市"
                    }
                ]
            },
            {
                "value": "赣州",
                "label": "赣州",
                "children": [
                    {
                        "value": "赣州",
                        "label": "赣州"
                    },
                    {
                        "value": "龙南市",
                        "label": "龙南市"
                    },
                    {
                        "value": "瑞金市",
                        "label": "瑞金市"
                    }
                ]
            },
            {
                "value": "景德镇",
                "label": "景德镇",
                "children": [
                    {
                        "value": "景德镇",
                        "label": "景德镇"
                    },
                    {
                        "value": "乐平市",
                        "label": "乐平市"
                    }
                ]
            },
            {
                "value": "萍乡",
                "label": "萍乡",

            },
            {
                "value": "新余",
                "label": "新余",

            },
            {
                "value": "鹰潭",
                "label": "鹰潭",
                "children": [
                    {
                        "value": "鹰潭",
                        "label": "鹰潭"
                    },
                    {
                        "value": "贵溪市",
                        "label": "贵溪市"
                    }
                ]
            }
        ]
    },
    {
        "value": "湖南",
        "label": "湖南",
        "children": [
            {
                "value": "长沙",
                "label": "长沙",
                "children": [
                    {
                        "value": "长沙",
                        "label": "长沙"
                    },
                    {
                        "value": "浏阳市",
                        "label": "浏阳市"
                    },
                    {
                        "value": "宁乡市",
                        "label": "宁乡市"
                    }
                ]
            },
            {
                "value": "湘潭",
                "label": "湘潭",
                "children": [
                    {
                        "value": "湘潭",
                        "label": "湘潭"
                    },
                    {
                        "value": "湘乡市",
                        "label": "湘乡市"
                    },
                    {
                        "value": "韶山市",
                        "label": "韶山市"
                    }
                ]
            },
            {
                "value": "株洲",
                "label": "株洲",
                "children": [
                    {
                        "value": "株洲",
                        "label": "株洲"
                    },
                    {
                        "value": "醴陵市",
                        "label": "醴陵市"
                    }
                ]
            },
            {
                "value": "衡阳",
                "label": "衡阳",
                "children": [
                    {
                        "value": "衡阳",
                        "label": "衡阳"
                    },
                    {
                        "value": "耒阳市",
                        "label": "耒阳市"
                    },
                    {
                        "value": "常宁市",
                        "label": "常宁市"
                    }
                ]
            },
            {
                "value": "郴州",
                "label": "郴州",
                "children": [
                    {
                        "value": "郴州",
                        "label": "郴州"
                    },
                    {
                        "value": "资兴市",
                        "label": "资兴市"
                    }
                ]
            },
            {
                "value": "常德",
                "label": "常德",
                "children": [
                    {
                        "value": "常德",
                        "label": "常德"
                    },
                    {
                        "value": "津市市",
                        "label": "津市市"
                    }
                ]
            },
            {
                "value": "益阳",
                "label": "益阳",
                "children": [
                    {
                        "value": "益阳",
                        "label": "益阳"
                    },
                    {
                        "value": "沅江市",
                        "label": "沅江市"
                    }
                ]
            },
            {
                "value": "娄底",
                "label": "娄底",
                "children": [
                    {
                        "value": "娄底",
                        "label": "娄底"
                    },
                    {
                        "value": "冷水江市",
                        "label": "冷水江市"
                    },
                    {
                        "value": "涟源市",
                        "label": "涟源市"
                    }
                ]
            },
            {
                "value": "邵阳",
                "label": "邵阳",
                "children": [
                    {
                        "value": "邵阳",
                        "label": "邵阳"
                    },
                    {
                        "value": "武冈市",
                        "label": "武冈市"
                    },
                    {
                        "value": "邵东市",
                        "label": "邵东市"
                    }
                ]
            },
            {
                "value": "岳阳",
                "label": "岳阳",
                "children": [
                    {
                        "value": "岳阳",
                        "label": "岳阳"
                    },
                    {
                        "value": "汨罗市",
                        "label": "汨罗市"
                    },
                    {
                        "value": "临湘市",
                        "label": "临湘市"
                    }
                ]
            },
            {
                "value": "张家界",
                "label": "张家界",

            },
            {
                "value": "怀化",
                "label": "怀化",
                "children": [
                    {
                        "value": "怀化",
                        "label": "怀化"
                    },
                    {
                        "value": "洪江市",
                        "label": "洪江市"
                    }
                ]
            },
            {
                "value": "永州",
                "label": "永州",
                "children": [
                    {
                        "value": "永州",
                        "label": "永州"
                    },
                    {
                        "value": "祁阳市",
                        "label": "祁阳市"
                    }
                ]
            },
            {
                "value": "湘西土家族苗族自治州",
                "label": "湘西土家族苗族自治州",
                "children": [
                    {
                        "value": "湘西土家族苗族自治州",
                        "label": "湘西土家族苗族自治州"
                    },
                    {
                        "value": "吉首市",
                        "label": "吉首市"
                    }
                ]
            }
        ]
    },
    {
        "value": "贵州",
        "label": "贵州",
        "children": [
            {
                "value": "贵阳",
                "label": "贵阳",
                "children": [
                    {
                        "value": "贵阳",
                        "label": "贵阳"
                    },
                    {
                        "value": "清镇市",
                        "label": "清镇市"
                    }
                ]
            },
            {
                "value": "遵义",
                "label": "遵义",
                "children": [
                    {
                        "value": "遵义",
                        "label": "遵义"
                    },
                    {
                        "value": "赤水市",
                        "label": "赤水市"
                    },
                    {
                        "value": "仁怀市",
                        "label": "仁怀市"
                    }
                ]
            },
            {
                "value": "安顺",
                "label": "安顺",

            },
            {
                "value": "铜仁",
                "label": "铜仁",

            },
            {
                "value": "毕节",
                "label": "毕节",
                "children": [
                    {
                        "value": "毕节",
                        "label": "毕节"
                    },
                    {
                        "value": "黔西市",
                        "label": "黔西市"
                    }
                ]
            },
            {
                "value": "六盘水",
                "label": "六盘水",
                "children": [
                    {
                        "value": "六盘水",
                        "label": "六盘水"
                    },
                    {
                        "value": "盘州市",
                        "label": "盘州市"
                    }
                ]
            },
            {
                "value": "黔东南苗族侗族自治州",
                "label": "黔东南苗族侗族自治州",
                "children": [
                    {
                        "value": "黔东南苗族侗族自治州",
                        "label": "黔东南苗族侗族自治州"
                    },
                    {
                        "value": "凯里市",
                        "label": "凯里市"
                    }
                ]
            },
            {
                "value": "黔南布依族苗族自治州",
                "label": "黔南布依族苗族自治州",
                "children": [
                    {
                        "value": "黔南布依族苗族自治州",
                        "label": "黔南布依族苗族自治州"
                    },
                    {
                        "value": "都匀市",
                        "label": "都匀市"
                    },
                    {
                        "value": "福泉市",
                        "label": "福泉市"
                    }
                ]
            },
            {
                "value": "黔西南布依族苗族自治州",
                "label": "黔西南布依族苗族自治州",
                "children": [
                    {
                        "value": "黔西南布依族苗族自治州",
                        "label": "黔西南布依族苗族自治州"
                    },
                    {
                        "value": "兴义市",
                        "label": "兴义市"
                    },
                    {
                        "value": "兴仁市",
                        "label": "兴仁市"
                    }
                ]
            }
        ]
    },
    {
        "value": "四川",
        "label": "四川",
        "children": [
            {
                "value": "成都",
                "label": "成都",
                "children": [
                    {
                        "value": "成都",
                        "label": "成都"
                    },
                    {
                        "value": "都江堰市",
                        "label": "都江堰市"
                    },
                    {
                        "value": "彭州市",
                        "label": "彭州市"
                    },
                    {
                        "value": "邛崃市",
                        "label": "邛崃市"
                    },
                    {
                        "value": "崇州市",
                        "label": "崇州市"
                    },
                    {
                        "value": "简阳市",
                        "label": "简阳市"
                    }
                ]
            },
            {
                "value": "攀枝花",
                "label": "攀枝花",

            },
            {
                "value": "自贡",
                "label": "自贡",

            },
            {
                "value": "绵阳",
                "label": "绵阳",
                "children": [
                    {
                        "value": "绵阳",
                        "label": "绵阳"
                    },
                    {
                        "value": "江油市",
                        "label": "江油市"
                    }
                ]
            },
            {
                "value": "南充",
                "label": "南充",
                "children": [
                    {
                        "value": "南充",
                        "label": "南充"
                    },
                    {
                        "value": "阆中市",
                        "label": "阆中市"
                    }
                ]
            },
            {
                "value": "达州",
                "label": "达州",
                "children": [
                    {
                        "value": "达州",
                        "label": "达州"
                    },
                    {
                        "value": "万源市",
                        "label": "万源市"
                    }
                ]
            },
            {
                "value": "遂宁",
                "label": "遂宁",
                "children": [
                    {
                        "value": "遂宁",
                        "label": "遂宁"
                    },
                    {
                        "value": "射洪市",
                        "label": "射洪市"
                    }
                ]
            },
            {
                "value": "广安",
                "label": "广安",
                "children": [
                    {
                        "value": "广安",
                        "label": "广安"
                    },
                    {
                        "value": "华蓥市",
                        "label": "华蓥市"
                    }
                ]
            },
            {
                "value": "巴中",
                "label": "巴中",

            },
            {
                "value": "泸州",
                "label": "泸州",

            },
            {
                "value": "宜宾",
                "label": "宜宾",

            },
            {
                "value": "内江",
                "label": "内江",
                "children": [
                    {
                        "value": "内江",
                        "label": "内江"
                    },
                    {
                        "value": "市中区",
                        "label": "市中区"
                    },
                    {
                        "value": "隆昌市",
                        "label": "隆昌市"
                    }
                ]
            },
            {
                "value": "资阳",
                "label": "资阳",

            },
            {
                "value": "乐山",
                "label": "乐山",
                "children": [
                    {
                        "value": "乐山",
                        "label": "乐山"
                    },
                    {
                        "value": "市中区",
                        "label": "市中区"
                    },
                    {
                        "value": "峨眉山市",
                        "label": "峨眉山市"
                    }
                ]
            },
            {
                "value": "眉山",
                "label": "眉山",

            },
            {
                "value": "雅安",
                "label": "雅安",

            },
            {
                "value": "德阳",
                "label": "德阳",
                "children": [
                    {
                        "value": "德阳",
                        "label": "德阳"
                    },
                    {
                        "value": "广汉市",
                        "label": "广汉市"
                    },
                    {
                        "value": "什邡市",
                        "label": "什邡市"
                    },
                    {
                        "value": "绵竹市",
                        "label": "绵竹市"
                    }
                ]
            },
            {
                "value": "广元",
                "label": "广元",

            },
            {
                "value": "阿坝藏族羌族自治州",
                "label": "阿坝藏族羌族自治州",
                "children": [
                    {
                        "value": "阿坝藏族羌族自治州",
                        "label": "阿坝藏族羌族自治州"
                    },
                    {
                        "value": "马尔康市",
                        "label": "马尔康市"
                    }
                ]
            },
            {
                "value": "凉山彝族自治州",
                "label": "凉山彝族自治州",
                "children": [
                    {
                        "value": "凉山彝族自治州",
                        "label": "凉山彝族自治州"
                    },
                    {
                        "value": "西昌市",
                        "label": "西昌市"
                    },
                    {
                        "value": "会理市",
                        "label": "会理市"
                    }
                ]
            },
            {
                "value": "甘孜藏族自治州",
                "label": "甘孜藏族自治州",
                "children": [
                    {
                        "value": "甘孜藏族自治州",
                        "label": "甘孜藏族自治州"
                    },
                    {
                        "value": "康定市",
                        "label": "康定市"
                    }
                ]
            }
        ]
    },
    {
        "value": "广东",
        "label": "广东",
        "children": [
            {
                "value": "广州",
                "label": "广州",

            },
            {
                "value": "韶关",
                "label": "韶关",
                "children": [
                    {
                        "value": "韶关",
                        "label": "韶关"
                    },
                    {
                        "value": "乐昌市",
                        "label": "乐昌市"
                    },
                    {
                        "value": "南雄市",
                        "label": "南雄市"
                    }
                ]
            },
            {
                "value": "惠州",
                "label": "惠州",

            },
            {
                "value": "梅州",
                "label": "梅州",
                "children": [
                    {
                        "value": "梅州",
                        "label": "梅州"
                    },
                    {
                        "value": "兴宁市",
                        "label": "兴宁市"
                    }
                ]
            },
            {
                "value": "汕头",
                "label": "汕头",

            },
            {
                "value": "深圳",
                "label": "深圳",

            },
            {
                "value": "珠海",
                "label": "珠海",

            },
            {
                "value": "佛山",
                "label": "佛山",

            },
            {
                "value": "肇庆",
                "label": "肇庆",
                "children": [
                    {
                        "value": "肇庆",
                        "label": "肇庆"
                    },
                    {
                        "value": "四会市",
                        "label": "四会市"
                    }
                ]
            },
            {
                "value": "湛江",
                "label": "湛江",
                "children": [
                    {
                        "value": "湛江",
                        "label": "湛江"
                    },
                    {
                        "value": "廉江市",
                        "label": "廉江市"
                    },
                    {
                        "value": "雷州市",
                        "label": "雷州市"
                    },
                    {
                        "value": "吴川市",
                        "label": "吴川市"
                    }
                ]
            },
            {
                "value": "江门",
                "label": "江门",
                "children": [
                    {
                        "value": "江门",
                        "label": "江门"
                    },
                    {
                        "value": "台山市",
                        "label": "台山市"
                    },
                    {
                        "value": "开平市",
                        "label": "开平市"
                    },
                    {
                        "value": "鹤山市",
                        "label": "鹤山市"
                    },
                    {
                        "value": "恩平市",
                        "label": "恩平市"
                    }
                ]
            },
            {
                "value": "河源",
                "label": "河源",

            },
            {
                "value": "清远",
                "label": "清远",
                "children": [
                    {
                        "value": "清远",
                        "label": "清远"
                    },
                    {
                        "value": "英德市",
                        "label": "英德市"
                    },
                    {
                        "value": "连州市",
                        "label": "连州市"
                    }
                ]
            },
            {
                "value": "云浮",
                "label": "云浮",
                "children": [
                    {
                        "value": "云浮",
                        "label": "云浮"
                    },
                    {
                        "value": "罗定市",
                        "label": "罗定市"
                    }
                ]
            },
            {
                "value": "潮州",
                "label": "潮州",

            },
            {
                "value": "东莞",
                "label": "东莞",

            },
            {
                "value": "中山",
                "label": "中山",

            },
            {
                "value": "阳江",
                "label": "阳江",
                "children": [
                    {
                        "value": "阳江",
                        "label": "阳江"
                    },
                    {
                        "value": "阳春市",
                        "label": "阳春市"
                    }
                ]
            },
            {
                "value": "揭阳",
                "label": "揭阳",
                "children": [
                    {
                        "value": "揭阳",
                        "label": "揭阳"
                    },
                    {
                        "value": "普宁市",
                        "label": "普宁市"
                    }
                ]
            },
            {
                "value": "茂名",
                "label": "茂名",
                "children": [
                    {
                        "value": "茂名",
                        "label": "茂名"
                    },
                    {
                        "value": "高州市",
                        "label": "高州市"
                    },
                    {
                        "value": "化州市",
                        "label": "化州市"
                    },
                    {
                        "value": "信宜市",
                        "label": "信宜市"
                    }
                ]
            },
            {
                "value": "汕尾",
                "label": "汕尾",
                "children": [
                    {
                        "value": "汕尾",
                        "label": "汕尾"
                    },
                    {
                        "value": "陆丰市",
                        "label": "陆丰市"
                    }
                ]
            },
            {
                "value": "东沙群岛",
                "label": "东沙群岛",

            }
        ]
    },
    {
        "value": "云南",
        "label": "云南",
        "children": [
            {
                "value": "昆明",
                "label": "昆明",
                "children": [
                    {
                        "value": "昆明",
                        "label": "昆明"
                    },
                    {
                        "value": "安宁市",
                        "label": "安宁市"
                    }
                ]
            },
            {
                "value": "曲靖",
                "label": "曲靖",
                "children": [
                    {
                        "value": "曲靖",
                        "label": "曲靖"
                    },
                    {
                        "value": "宣威市",
                        "label": "宣威市"
                    }
                ]
            },
            {
                "value": "保山",
                "label": "保山",
                "children": [
                    {
                        "value": "保山",
                        "label": "保山"
                    },
                    {
                        "value": "腾冲市",
                        "label": "腾冲市"
                    }
                ]
            },
            {
                "value": "玉溪",
                "label": "玉溪",
                "children": [
                    {
                        "value": "玉溪",
                        "label": "玉溪"
                    },
                    {
                        "value": "澄江市",
                        "label": "澄江市"
                    }
                ]
            },
            {
                "value": "普洱",
                "label": "普洱",

            },
            {
                "value": "昭通",
                "label": "昭通",
                "children": [
                    {
                        "value": "昭通",
                        "label": "昭通"
                    },
                    {
                        "value": "水富市",
                        "label": "水富市"
                    }
                ]
            },
            {
                "value": "临沧",
                "label": "临沧",

            },
            {
                "value": "丽江",
                "label": "丽江",

            },
            {
                "value": "西双版纳傣族自治州",
                "label": "西双版纳傣族自治州",
                "children": [
                    {
                        "value": "西双版纳傣族自治州",
                        "label": "西双版纳傣族自治州"
                    },
                    {
                        "value": "景洪市",
                        "label": "景洪市"
                    }
                ]
            },
            {
                "value": "文山壮族苗族自治州",
                "label": "文山壮族苗族自治州",
                "children": [
                    {
                        "value": "文山壮族苗族自治州",
                        "label": "文山壮族苗族自治州"
                    },
                    {
                        "value": "文山市",
                        "label": "文山市"
                    }
                ]
            },
            {
                "value": "红河哈尼族彝族自治州",
                "label": "红河哈尼族彝族自治州",
                "children": [
                    {
                        "value": "红河哈尼族彝族自治州",
                        "label": "红河哈尼族彝族自治州"
                    },
                    {
                        "value": "个旧市",
                        "label": "个旧市"
                    },
                    {
                        "value": "开远市",
                        "label": "开远市"
                    },
                    {
                        "value": "蒙自市",
                        "label": "蒙自市"
                    },
                    {
                        "value": "弥勒市",
                        "label": "弥勒市"
                    }
                ]
            },
            {
                "value": "德宏傣族景颇族自治州",
                "label": "德宏傣族景颇族自治州",
                "children": [
                    {
                        "value": "德宏傣族景颇族自治州",
                        "label": "德宏傣族景颇族自治州"
                    },
                    {
                        "value": "瑞丽市",
                        "label": "瑞丽市"
                    },
                    {
                        "value": "芒市",
                        "label": "芒市"
                    }
                ]
            },
            {
                "value": "怒江傈僳族自治州",
                "label": "怒江傈僳族自治州",
                "children": [
                    {
                        "value": "怒江傈僳族自治州",
                        "label": "怒江傈僳族自治州"
                    },
                    {
                        "value": "泸水市",
                        "label": "泸水市"
                    }
                ]
            },
            {
                "value": "迪庆藏族自治州",
                "label": "迪庆藏族自治州",
                "children": [
                    {
                        "value": "迪庆藏族自治州",
                        "label": "迪庆藏族自治州"
                    },
                    {
                        "value": "香格里拉市",
                        "label": "香格里拉市"
                    }
                ]
            },
            {
                "value": "大理白族自治州",
                "label": "大理白族自治州",
                "children": [
                    {
                        "value": "大理白族自治州",
                        "label": "大理白族自治州"
                    },
                    {
                        "value": "大理市",
                        "label": "大理市"
                    }
                ]
            },
            {
                "value": "楚雄彝族自治州",
                "label": "楚雄彝族自治州",
                "children": [
                    {
                        "value": "楚雄彝族自治州",
                        "label": "楚雄彝族自治州"
                    },
                    {
                        "value": "楚雄市",
                        "label": "楚雄市"
                    },
                    {
                        "value": "禄丰市",
                        "label": "禄丰市"
                    }
                ]
            }
        ]
    },
    {
        "value": "广西",
        "label": "广西",
        "children": [
            {
                "value": "南宁",
                "label": "南宁",
                "children": [
                    {
                        "value": "南宁",
                        "label": "南宁"
                    },
                    {
                        "value": "横州市",
                        "label": "横州市"
                    }
                ]
            },
            {
                "value": "崇左",
                "label": "崇左",
                "children": [
                    {
                        "value": "崇左",
                        "label": "崇左"
                    },
                    {
                        "value": "凭祥市",
                        "label": "凭祥市"
                    }
                ]
            },
            {
                "value": "柳州",
                "label": "柳州",

            },
            {
                "value": "来宾",
                "label": "来宾",
                "children": [
                    {
                        "value": "来宾",
                        "label": "来宾"
                    },
                    {
                        "value": "合山市",
                        "label": "合山市"
                    }
                ]
            },
            {
                "value": "桂林",
                "label": "桂林",
                "children": [
                    {
                        "value": "桂林",
                        "label": "桂林"
                    },
                    {
                        "value": "荔浦市",
                        "label": "荔浦市"
                    }
                ]
            },
            {
                "value": "梧州",
                "label": "梧州",
                "children": [
                    {
                        "value": "梧州",
                        "label": "梧州"
                    },
                    {
                        "value": "岑溪市",
                        "label": "岑溪市"
                    }
                ]
            },
            {
                "value": "贺州",
                "label": "贺州",

            },
            {
                "value": "贵港",
                "label": "贵港",
                "children": [
                    {
                        "value": "贵港",
                        "label": "贵港"
                    },
                    {
                        "value": "桂平市",
                        "label": "桂平市"
                    }
                ]
            },
            {
                "value": "玉林",
                "label": "玉林",
                "children": [
                    {
                        "value": "玉林",
                        "label": "玉林"
                    },
                    {
                        "value": "北流市",
                        "label": "北流市"
                    }
                ]
            },
            {
                "value": "百色",
                "label": "百色",
                "children": [
                    {
                        "value": "百色",
                        "label": "百色"
                    },
                    {
                        "value": "靖西市",
                        "label": "靖西市"
                    },
                    {
                        "value": "平果市",
                        "label": "平果市"
                    }
                ]
            },
            {
                "value": "钦州",
                "label": "钦州",

            },
            {
                "value": "河池",
                "label": "河池",

            },
            {
                "value": "北海",
                "label": "北海",

            },
            {
                "value": "防城港",
                "label": "防城港",
                "children": [
                    {
                        "value": "防城港",
                        "label": "防城港"
                    },
                    {
                        "value": "东兴市",
                        "label": "东兴市"
                    }
                ]
            }
        ]
    },
    {
        "value": "海南",
        "label": "海南",
        "children": [
            {
                "value": "海口",
                "label": "海口",

            },
            {
                "value": "三亚",
                "label": "三亚",

            },
            {
                "value": "三沙",
                "label": "三沙",

            },
            {
                "value": "儋州",
                "label": "儋州",

            },
            {
                "value": "五指山",
                "label": "五指山",

            },
            {
                "value": "琼海",
                "label": "琼海",

            },
            {
                "value": "文昌",
                "label": "文昌",

            },
            {
                "value": "万宁",
                "label": "万宁",

            },
            {
                "value": "东方",
                "label": "东方",

            },
            {
                "value": "定安",
                "label": "定安",

            },
            {
                "value": "屯昌",
                "label": "屯昌",

            },
            {
                "value": "澄迈",
                "label": "澄迈",

            },
            {
                "value": "临高",
                "label": "临高",

            },
            {
                "value": "白沙黎族自治县",
                "label": "白沙黎族自治县",

            },
            {
                "value": "昌江黎族自治县",
                "label": "昌江黎族自治县",

            },
            {
                "value": "乐东黎族自治县",
                "label": "乐东黎族自治县",

            },
            {
                "value": "陵水黎族自治县",
                "label": "陵水黎族自治县",

            },
            {
                "value": "保亭黎族苗族自治县",
                "label": "保亭黎族苗族自治县",

            },
            {
                "value": "琼中黎族苗族自治县",
                "label": "琼中黎族苗族自治县",

            }
        ]
    },
    {
        "value": "香港",
        "label": "香港",
        "children": [
            {
                "value": "香港",
                "label": "香港",

            }
        ]
    },
    {
        "value": "澳门",
        "label": "澳门",
        "children": [
            {
                "value": "澳门",
                "label": "澳门",

            }
        ]
    },
    {
        "value": "台湾",
        "label": "台湾",
        "children": [
            {
                "value": "台湾",
                "label": "台湾",

            }
        ]
    }

]
// 行业
export const industryOption = [
    {
        value: "互联网/AI",
        label: "互联网/AI",
        children: [
            {
                label: "互联网",
                value: "互联网",
            },
            {
                label: "电子商务",
                value: "电子商务",
            },
            {
                label: "计算机软件",
                value: "计算机软件",
            }, {
                label: "生活服务(O2O)",
                value: "生活服务(O2O)",
            }, {
                label: "企业服务",
                value: "企业服务",
            }, {
                label: "医疗健康",
                value: "医疗健康",
            }, {
                label: "游戏",
                value: "游戏",
            },
        ],
    }, {
        value: "电子/通信/半导体",
        label: "电子/通信/半导体",
        children: [
            {
                label: "半导体/芯片",
                value: "半导体/芯片",
            },
            {
                label: "电子/硬件开发",
                value: "电子/硬件开发",
            },
            {
                label: "通信/网络设备",
                value: "通信/网络设备",
            }, {
                label: "智能硬件/消费电子",
                value: "智能硬件/消费电子",
            }, {
                label: "运营商/增值服务",
                value: "运营商/增值服务",
            }, {
                label: "计算机硬件",
                value: "计算机硬件",
            },
        ],
    }, {
        value: "服务业",
        label: "服务业",
        children: [
            {
                label: "餐饮",
                value: "餐饮",
            },
            {
                label: "美容",
                value: "美容",
            },
            {
                label: "美发",
                value: "美发",
            }, {
                label: "酒店/民宿",
                value: "酒店/民宿",
            }, {
                label: "休闲/娱乐",
                value: "休闲/娱乐",
            }, {
                label: "运动健身",
                value: "运动健身",
            }, {
                label: "保健/养生",
                value: "保健/养生",
            },
        ],
    }, {
        value: "消费品/批发/零售",
        label: "消费品/批发/零售",
        children: [
            {
                label: "批发/零售",
                value: "批发/零售",
            },
            {
                label: "进出口贸易",
                value: "进出口贸易",
            },
            {
                label: "食品/饮料/烟酒",
                value: "食品/饮料/烟酒",
            }, {
                label: "服装/纺织",
                value: "服装/纺织",
            },
        ],
    }, {
        value: "房地产/建筑",
        label: "房地产/建筑",
        children: [
            {
                label: "装修装饰",
                value: "装修装饰",
            },
            {
                label: "房屋建筑工程",
                value: "房屋建筑工程",
            },

        ],
    }, {
        value: "教育培训",
        label: "教育培训",
        children: [
            {
                label: "培训/辅导机构",
                value: "培训/辅导机构",
            },
            {
                label: "职业培训",
                value: "职业培训",
            },

        ],
    }, {
        value: "广告/传媒",
        label: "广告/传媒",
        children: [
            {
                label: "文化/艺术/娱乐",
                value: "体育",
            },
            {
                label: "体育",
                value: "体育",
            },

        ],
    }, {
        value: "制造业",
        label: "制造业",
        children: [
            {
                label: "通用设备",
                value: "通用设备",
            },
            {
                label: "专用设备",
                value: "专用设备",
            },

        ],
    }, {
        value: "专业服务",
        label: "专业服务",
        children: [
            {
                label: "咨询",
                value: "咨询",
            },
            {
                label: "财务/审计/税务",
                value: "财务/审计/税务",
            },

        ],
    }, {
        value: "制药/医疗",
        label: "制药/医疗",
        children: [
            {
                label: "医疗服务",
                value: "医疗服务",
            },
            {
                label: "医美服务",
                value: "医美服务",
            },

        ],
    }, {
        value: "汽车",
        label: "汽车",
        children: [
            {
                label: "新能源汽车",
                value: "新能源汽车",
            },
            {
                label: "汽车智能网联",
                value: "汽车智能网联",
            },

        ],
    },
]
export const Educational = [{
    value: "初中及以下",
    label: "初中及以下"
}, {
    value: "中专/中技",
    label: "中专/中技"
}, {
    value: "高中",
    label: "高中"
}, {
    value: "大专",
    label: "大专"
}, {
    value: "本科",
    label: "本科"
}, {
    value: "硕士",
    label: "硕士"
}, {
    value: "博士",
    label: "博士"
},
]
export const educationalSystem = [{
    value: "全日制",
    label: "全日制"
}, {
    value: "非全日制",
    label: "非全日制"
},]
export const getOptionArray = (arr, stry) => {
    let arr_industry = [];
    arr.forEach((item) => {
        if (item.children) {
            item.children.forEach((item1) => {
                if (item1.children) {
                    item1.children.forEach(item2 => {
                        let arr = stry.split("、");
                        if (arr.includes(item2.value)) {
                            arr_industry.push([item.value, item1.value,item2.value]);
                        }
                    })

                } else {
                    let arr = stry.split("、");
                    if (arr.includes(item1.value)) {
                        arr_industry.push([item.value, item1.value]);
                    }
                }

            });
        }
    });
    return arr_industry;
}
